import { Checkbox, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Dialog, DialogActions, Button, DialogContent, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import Highlighter from "react-highlight-words";
import { connect } from 'react-redux';
import { setLabourSelection, setMaterialSelection, setSelection, setDefectFilterKey } from '../../store/actions';
import { checkHomewhiz } from 'src/utils/storage/StartWorkOrder'

const useStyles = makeStyles({
  table: {
    width: '100%',
    minHeight: 500,
  },
});

const DefectTable = (props) => {
  const classes = useStyles();
  const selected = props.defects.selected;
  const currentFis = JSON.parse(localStorage.getItem('baslandiFis'));

  const [alertOpen, setAlertOpen] = React.useState(false);
  const [alertMsg, setAlertMsg] = React.useState('');

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      // Add
      newSelected = [...selected, name];
      const kul_hizmet_kodu = props.defects?.defectsTable[name]?.UserCode
      const hizmet_isciligi = props.labours?.Data?.filter(d => d.LabourCode === kul_hizmet_kodu);
      if (hizmet_isciligi.length > 0) {
        props.setLabourSelection(name, [kul_hizmet_kodu]);
      }
      //kul_hizmet_kodu === '514' || kul_hizmet_kodu === '627' || kul_hizmet_kodu === '628' ||  kul_hizmet_kodu === '629' || kul_hizmet_kodu === '5514'
      if (kul_hizmet_kodu === '514') {
        if (checkHomewhiz(false)) {
          setAlertMsg('Ürün Homewhiz özelliklidir. Homewhiz kurulumunu yapınız!..');
          setAlertOpen(true);
        }
      }
      //
      // if ((kul_hizmet_kodu === '313')){
      //   setAlertMsg('Klima iç ünitesine yapılan müdahale sonucunda dış üniteye gaz şarjı uygulanması durumunda ‘’313 Gaz şarjı’’  ve ‘’2524-Klima iç ünite kaynaklı gaz şarjı’’ hizmet kodları beraber kullanılmalıdır.');
      //   setAlertOpen(true);
      // }
    } else {
      // Remove
      newSelected = [...selected.slice(0, selectedIndex)
        , ...selected.slice(selectedIndex + 1)
      ]
      props.setLabourSelection(name, []);
      props.setMaterialSelection(name, []);
    }
    props.setDefectFilterKey("");
    props.setSelection(newSelected);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  let filteredRows = props?.defects?.filtered; // MHTU-3427
  if (currentFis?.SU_ARITMA_KONTROL === 1) {
    filteredRows = filteredRows?.filter(row => row.Code === 1570);
  }

  // Duplicate hizmetleri kaldır - Code'a göre unique yap
  if (filteredRows) {
    const uniqueMap = new Map();
    filteredRows.forEach(row => {
      if (!uniqueMap.has(row.Code)) {
        uniqueMap.set(row.Code, row);
      }
    });
    filteredRows = Array.from(uniqueMap.values());
  }

  const highlight = (text) => {
    return <Highlighter
      searchWords={[props.defects.filterKey]}
      autoEscape={true}
      textToHighlight={text}
    />
  }
  return (
    <TableContainer className={classes.table} component={Paper}>
      <Table size="small" aria-label="defect table">
        <TableHead>
          <TableRow>
            <TableCell>Hizmet</TableCell>
            <TableCell>Seç</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(filteredRows) && filteredRows.sort(s => isSelected(s.Code) ? -1 : 1).map((row, index) => {
            const labelId = `enhanced-table-checkbox-${index}`;
            const isItemSelected = isSelected(row.Code);
            return (
              <TableRow
                onClick={(event) => handleClick(event, row.Code)}
                role="checkbox"
                aria-checked={isItemSelected}
                tabIndex={-1}
                key={`${row.Code}-${index}`}
                selected={isItemSelected}
              >
                <TableCell component="th" scope="row">
                  <b>{highlight(row.UserCode)}</b>
                  {" "}
                  {highlight(row.DefectDesc)}
                </TableCell>
                <TableCell padding="checkbox">
                  <Checkbox
                    color="primary"
                    checked={isItemSelected}
                    inputProps={{ 'aria-labelledby': labelId }}
                  />
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
      <Dialog
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
      >
        <DialogContent>
          <Typography variant="h6" component="h4">
            {alertMsg}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAlertOpen(false)} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
    </TableContainer>

  );
}


const mapStateToProps = (state) => ({
  defects: state.defectReducer,
  labours: state.labourReducer,
});

const mapDispatchToProps = {
  setSelection: setSelection,
  setLabourSelection: setLabourSelection,
  setMaterialSelection: setMaterialSelection,
  setDefectFilterKey: setDefectFilterKey,
};

export default connect(mapStateToProps, mapDispatchToProps)(DefectTable)
